import { render, staticRenderFns } from "./StaffCheckin.vue?vue&type=template&id=54fb6c10"
import script from "./StaffCheckin.vue?vue&type=script&lang=js"
export * from "./StaffCheckin.vue?vue&type=script&lang=js"
import style0 from "./StaffCheckin.vue?vue&type=style&index=0&id=54fb6c10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports